import React, { useEffect, useRef } from "react"
import { Box, Grid, Typography } from "@kohler-dsm-library/kohler-core"
import styles from "@/components/Remedy/components/TimerVideoBlock/TimerVideoBlock.module.scss"
import { handleVideoPlayedAnalytics } from "@/components/Remedy/components/analytics"

export const TimerVideoBlock = () => {
  const videoContainerRef = useRef(null)

  useEffect(() => {
    if (!videoContainerRef.current) return

    const videoElement = videoContainerRef.current.querySelector("video")

    const sourceVideo = videoElement?.querySelector("source")

    if (!videoElement) return

    const handleIntersection = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          videoElement.play()
          handleVideoPlayedAnalytics(
            "Guided breathwork and time",
            sourceVideo?.src,
            true,
            videoElement?.id
          )
          observer.unobserve(videoElement)
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: [0.5],
    })

    observer.observe(videoElement)

    return () => {
      observer.unobserve(videoElement)
    }
  }, [])

  return (
    <Box
      component="section"
      mod="charcoal"
      className={styles["timer-video-section"]}
    >
      <Grid>
        <Typography className={styles["__title"]} size="h3" component="span">
          Guided breathwork and timer
        </Typography>
        <Typography
          size="paragraph-large"
          className={styles["__description"]}
          component="span"
        >
          An integrated timer and breath light aid in breath regulation and
          session tracking. An integrated smartphone slot allows for guided
          coaching sessions with Dr. Jonathan Leary and more via the KOHLER
          Konnect® app.
        </Typography>
        <div
          ref={videoContainerRef}
          className={styles["__video-container"]}
          dangerouslySetInnerHTML={{
            __html: `
          <video preload="metadata" muted loop playsinline id="timervideo">
            <source src="https://kohler.scene7.com/is/content/${
              process.env.NEXT_PUBLIC_AUTHORBASEURL?.includes("www.kohler.com")
                ? "kohlergbhprod"
                : "kohlergbhqa"
            }/PXP/Breathlight.mp4" />
          </video>
        `,
          }}
        />
      </Grid>
    </Box>
  )
}
